import { render, staticRenderFns } from "./statustempattinggal.vue?vue&type=template&id=26855c74"
import script from "./statustempattinggal.vue?vue&type=script&lang=js"
export * from "./statustempattinggal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports